export enum RuleAction {
  MAKE_REQUIRED = 0,
  MAKE_NOT_REQUIRED = 1,
  MAKE_DISABLED = 2,
  MAKE_ENABLED = 3,
  MAKE_HIDDEN = 4,
  MAKE_VISIBLE = 5,
  SET_VALUE = 6,
  INCREMENT_VALUE = 7,
  MAKE_INVALID = 8,
  SET_MIN_VALUE = 9,
  SET_MAX_VALUE = 10,
  SHOW_TOOLTIP = 11,
  HIDE_TOOLTIP = 12,
  SET_TOOLTIP = 13,
  MAKE_READONLY = 14,
  SET_ERROR_MESSAGE = 15,
  CLEAR_ERROR_MESSAGE = 16,
  SET_WARNING_MESSAGE = 17,
  SHOW_WARNING_ICON = 18,
  HIDE_WARNING_ICON = 19,
  SET_WARNING_TOOLTIP = 20,
  SET_HINT_TEXT = 21,
}
